// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1527":"b5535622","7517":"bd2b8efc"}[chunkId] + ".chunk.css";
};